import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Ordered} from '../models/ordered';
import {Agenda} from '../models/agenda';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionsService {

    constructor (
        private _httpClient: HttpClient,
        private db: AngularFirestore) { }

    getSubscriptions (): Observable<any> {

        //url
        let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getSubscriptions';

        // Headers
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: '5AA6C5E4-28E7-4EF9-A608-733B760D703D'
            })
        };

        return this._httpClient.get<any>(url, httpOptions)
            .pipe(
                retry(2),
                catchError(this.handleError)
            )
    }

    // Manipulação de erros
    handleError (error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Erro ocorreu no lado do client
            errorMessage = error.error.message;
        } else {
            // Erro ocorreu no lado do servidor
            errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    };

    ///////////////////////////////////////

    select () {
        const product_id = "ZGcChwgisgQfjtjoq2Vk";
        return this.db.collection<Ordered>('sbccv_orders', ref => ref
            .where("returnCode", "==", "00")
            .where("product_id", "==", product_id)
            .orderBy("date", 'desc')).snapshotChanges();
    }

    selectAgendaStaff (event_id) {
        return this.db.collection<Agenda>('sbccv_agenda', ref => ref
            .where('event_id', '==', event_id)
            .orderBy("event_name", 'desc')).snapshotChanges();
    }

    update (entity: any) {
        let id = entity.id;
        delete entity.id;
        return this.db.collection('sbccv_orders').doc(id)
            .set(Object.assign({}, entity), {'merge': true});
    }

    isValidCPF (cpf) {
        if (typeof cpf !== "string") return false
        cpf = cpf.replace(/[\s.-]*/igm, '')

        if (cpf.length !== 11 || !Array.from(cpf).filter(e => e !== cpf[0]).length) {
            return false
        }

        var soma = 0
        var resto
        for (var i = 1; i <= 9; i++)
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
        resto = (soma * 10) % 11
        if ((resto == 10) || (resto == 11)) resto = 0
        if (resto != parseInt(cpf.substring(9, 10))) return false
        soma = 0
        for (var i = 1; i <= 10; i++)
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
        resto = (soma * 10) % 11
        if ((resto == 10) || (resto == 11)) resto = 0
        if (resto != parseInt(cpf.substring(10, 11))) return false
        return true
    }

    isValidEmail (email) {
        var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return email.match(emailRegex)
    };

}

